import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../shared/auth/auth.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment.development';
import { MatSidenav } from '@angular/material/sidenav';
import { ComponentService } from '../../../../shared/abstract/component.service';
import { RoleEnums } from '../../../../shared/enum/authorize';
import { UserComponent } from './user/user.component';
import { MapComponentService } from '../../../../shared/map/map.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent extends ComponentService<any> implements OnInit ,OnDestroy {
  @Input() isMenuOpened!: boolean;
  @ViewChild('header') header!: MatToolbar;
  @ViewChild('headerTile') headerTile!: MatButton;
  sidenavOpen: boolean = false;
  @ViewChild('rightSidebar') rightSidenav!: MatSidenav;
  @ViewChild(UserComponent) appUserComponent!: UserComponent;

  //logoUrl!: any;
  @Output() isShowSidebar = new EventEmitter<boolean>();
  //@Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  apiUrl: any;
  selectedCompany: any;
  roleEnums = RoleEnums;
  mobileQuery!: MediaQueryList;
  filterCompanies!: any;
  formType!: any;
  companies!: any;
  selectedProjectId: any;
  selectedCompanyId: any;
  projects: any = [];
  isLoaded: boolean = false;
  selectedProject: any;
  checked :boolean = true;
  disabled: boolean = false;
  userInfos: any;
  imageUrl: any;
  languageValue;
  languages = [
    { value: 'tr-TR', viewValue: 'Türkçe' },
    { value: 'en-US', viewValue: 'English' },
    { value: 'de-DE', viewValue: 'Deutsch' },
    { value: 'ky-KZ', viewValue: 'Arabic' }
  ];

  private _mobileQueryListener!: () => void;
  //public user$: Observable<User>
  //public emails$: Observable<Email[]>
  myEventSubscription: any;
  companyLogoSubscription!: Subscription;
  logoUrl = environment.defaultLogoPath;
  constructor(
    injector: Injector,
    public jwtHelper: JwtHelperService,
    private _auth: AuthService,
    private _map: MapComponentService,
    media: MediaMatcher,
    private _router: Router,
    changeDetectorRef: ChangeDetectorRef,
    //private emailService: EmailService,
    private router: Router,
  ) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    //this.apiUrl = environment.apiUrl + "/"
    //this.user$ = this.userService.getUser();
    //this.emails$ = this.emailService.loadEmails();
  }

  ngOnInit(): void {
    //this._map.initMap("work-force");
    this.formType = 0;
  }

  ngOnDestroy() {
  }

  change(key: string) {
    localStorage.setItem('langKey', key);
    this._appsService.language = key;
    this.translate.setDefaultLang(key);
  }

  public openMenu(): void {
    this.isMenuOpened = !this.isMenuOpened;
    this.isShowSidebar.emit(this.isMenuOpened);
    //this._map.map ? this._map.resizeMap() : null;
  }

  managementPanel() {

    //this._router.navigate(['application']);
    window.location.href = '#/application';
  }


  getCurrentStatus(status: any) {

    this.sidenavOpen = status;

  }

  closeSidebar(): void {
    this.appUserComponent.openUserProfile(); // Trigger openUserProfile in app-user
  }

  public signOutEmit(): void {
    //this.signOut.emit();
  }


  public signOut(): void {
    this._auth.logout().then((res) => {
      if (res) {
        const language = localStorage.getItem('langKey');
        const theme = localStorage.getItem('theme') ?? 'work-force-default';
        localStorage.clear();
        language ? localStorage.setItem('langKey', language) : null;
        theme ? localStorage.setItem('theme', theme) : null;

        this._router.navigate(['account/login']);
      } else {
        this.MessageBox(this.languageKey("anErrorOccuredOperation"), 'warn', 'center');
      }
    }).catch((err) => {
      this.MessageBox(err.message, 'warn', 'center');
    })
  }


  pwdChange() {
    //const dialogRef = this._dialog.open(ModalComponent, {
    //  data: {
    //    type: 'pwdChange',
    //    title: 'UpdatePassword',
    //    body: 'logging',
    //    cancel: 'cancel',
    //    data: { counter: 30 },
    //    ok: 'updatepwd',
    //    color: 'primary'
    //  }
    //});
    //dialogRef.afterClosed().subscribe(result => {
    ////  if (result) {
    ////    const model = new ChangePasswordModel();
    ////    model.currentPassword = result.currentPwd.toString();
    ////    model.newPassword = result.pwd.toString();
    ////    this._service.changePassword(model).toPromise().then((_) => {
    ////      /*this.MessageBox(_.message ?? '', _.code == 1 ? 'mat-primary' : 'mat-warn', 'right');*/
    ////      if (_.code == ResultCode._1) {
    ////        this.MessageBox(_.message ?? '', 'primary', 'center');
    ////      }
    ////      else if (_.code == ResultCode._2) {
    ////        this.MessageBox(_.message ?? '', 'orange', 'center');
    ////      }
    ////      else {
    ////        this.MessageBox(_.message ?? '', 'warn', 'center');
    ////      }
    ////    })
    ////  }
    //})
  }

}
